import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { CtaBand } from '../components/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { faqs } from '../data/faqs';
const categories = Array.from(new Set(faqs.map(faq => faq.category.en)));
export function Faq() {
  const {
    t,
    lang
  } = useLanguage();
  const [open, setOpen] = useState<string | null>(faqs[0].question.en);
  const page = copy.pages.faq;
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    inLanguage: lang,
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: t(faq.question),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(faq.answer)
      }
    }))
  };
  return <>
      <Seo title={t(copy.seo.faq.title)} description={t(copy.seo.faq.description)} schema={faqSchema} data-id="element-375" data-mp="3lspl3dfiuca8" />
      <PageHeader eyebrow={t(page.eyebrow)} title={t(page.title)} description={t(page.description)} data-id="element-376" data-mp="266t85vo0pui3" />

      <section className="bg-white py-14 sm:py-16" data-id="element-377" data-mp="2f4lon35h7872">
        <div className="mx-auto max-w-3xl px-6" data-id="element-378" data-mp="2f77w72sd9npa">
          {categories.map(category => {
          const group = faqs.filter(faq => faq.category.en === category);
          return <div key={category} className="mb-12 last:mb-0" data-id="element-379" data-mp="2p32kadfd0azg">
                <h2 className="font-display text-sm font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-380" data-mp="2t3ut55kbkdv7">
                  {t(group[0].category)}
                </h2>
                <ul className="mt-4 divide-y divide-navy-100 border-t border-navy-100" data-id="element-381" data-mp="32upp51ndartu">
                  {group.map(faq => {
                const isOpen = open === faq.question.en;
                return <li key={faq.question.en} data-id="element-382" data-mp="3cs3xedz50ab2">
                        <h3 data-id="element-383" data-mp="3cqstme5oz2jy">
                          <button type="button" onClick={() => setOpen(isOpen ? null : faq.question.en)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-384" data-mp="2n4hymtuwxc9q">
                            <span className="font-display text-lg font-semibold text-navy-900" data-id="element-385" data-mp="35uzehxuncddo">
                              {t(faq.question)}
                            </span>
                            <ChevronDownIcon width={20} height={20} aria-hidden="true" className={`mt-1 shrink-0 text-navy-500 transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-180' : ''}`} data-id="element-386" data-mp="30yio0wzz5mxf" />
                          </button>
                        </h3>
                        <AnimatePresence initial={false} data-id="element-387" data-mp="3s4g5k4lc5r2d">
                          {isOpen && <motion.div initial={{
                      height: 0,
                      opacity: 0
                    }} animate={{
                      height: 'auto',
                      opacity: 1
                    }} exit={{
                      height: 0,
                      opacity: 0
                    }} transition={{
                      duration: 0.22,
                      ease: [0.23, 1, 0.32, 1]
                    }} className="overflow-hidden" data-id="element-388" data-mp="wkacjxxb9dp">
                              <p className="pb-6 pr-8 leading-relaxed text-navy-600" data-id="element-389" data-mp="2zhby7syrt0nf">
                                {t(faq.answer)}
                              </p>
                            </motion.div>}
                        </AnimatePresence>
                      </li>;
              })}
                </ul>
              </div>;
        })}
        </div>
      </section>

      <CtaBand title={page.ctaTitle} description={page.ctaDescription} data-id="element-390" data-mp="2tq947340s8d9" />
    </>;
}